import { Component, OnInit } from '@angular/core';
import * as XLSX from 'xlsx';
import { AwsService } from "../../../providers/appsyncservice/aws.service";

@Component({
  selector: 'app-house-upload',
  templateUrl: './house-upload.component.html',
  styleUrls: ['./house-upload.component.css']
})
export class HouseUploadComponent implements OnInit {
  file: File
  displayValue: number = 0;
  progresspercent: number = 0;
  uploadStatus: Number;
  uploadList: any[] = [];
  statusList: any[] = [];
  arrayBuffer: any;
  sheetlength: number = 0;
  cnt: number = 1;
  vendorList: any = [];
  userList: any = [];

  constructor(public awserviceProvider: AwsService) { }

  ngOnInit() {
    this.progresspercent = 0;
    this.getVendorData();
  }

  incomingfile(event) {
    this.uploadStatus = -1;
    this.file = event.target.files[0];
    // alert( this.file.name)
  }

  uploadtrip() {
    console.log('Upload_trip')
    if (this.file == undefined) {
      this.uploadStatus = 0;
      return;
    }

    this.statusList = [];
    this.uploadList = [];
    this.progresspercent = 0;
    this.uploadStatus = 1;
    this.displayValue = 0;
    this.userList = [];

    let fileReader = new FileReader();
    fileReader.onload = (e) => {
      //alert("inside");
      // this.uploadStatus = 1;
      this.arrayBuffer = fileReader.result;
      var data = new Uint8Array(this.arrayBuffer);
      var arr = new Array();
      for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
      var bstr = arr.join("");
      var workbook = XLSX.read(bstr, { type: "binary" });
      var first_sheet_name = workbook.SheetNames[0];
      console.log("first_sheet_name", first_sheet_name);
      var worksheet = workbook.Sheets["data"];
      var sheet = XLSX.utils.sheet_to_json(worksheet, { raw: true })
      // console.log("first_sheet_json", sheet.toString);
      console.log("first_sheet_length", sheet.length);
      this.sheetlength = sheet.length;
      this.startProcess(sheet);
    }
    fileReader.readAsArrayBuffer(this.file);
    this.uploadStatus = 1;
  }

  //After reading insert the record 
  async startProcess(sheet) {
    // bar.update(0.5);
    // console.log("FULL", sheet)
    var rnNumberSet = new Set();
    for (const dict of sheet) {

      var s_no = String(dict["S.No"]).trim();
      var house_address = String(dict["House Address"]).trim();
      var house_location = String(dict["House Location"]).trim();
      var house_city = String(dict["House City"]).trim();
      var house_size = String(dict["House Size"]).trim();
      var house_type = String(dict["House Type"]).trim();
      var owner_name = String(dict["Owner Name"]).trim();
      var owner_email = String(dict["Owner Email"]).trim();
      var owner_phone = String(dict["Owner Phone"]).trim();
      var owner_address = String(dict["Owner Address"]).trim();
      var lease_start_date = String(dict["Lease Start Date"]).trim();
      var lease_end_date = String(dict["Lease End Date"]).trim();
      var vendor_name = String(dict["Vendor Name"]).trim();
      var rn_number = String(dict["RN Number"]).trim();
      var assigned_date = String(dict["Assigned Date"]).trim();

      console.log('s_no: ' + s_no
        + ' house_address: ' + house_address + ' house_location: ' + house_location
        + ' house_city: ' + house_city + ' house_size: ' + house_size + ' house_type: ' + house_type
        + ' owner_name: ' + owner_name + ' owner_email: ' + owner_email
        + ' owner_phone: ' + owner_phone + ' owner_address: ' + owner_address
        + ' lease_start_date: ' + lease_start_date + ' lease_end_date: ' + lease_end_date
        + ' vendor_name: ' + vendor_name + ' rn_number: ' + rn_number + ' assigned_date: ' + assigned_date);

      var houseData = {
        'house_address': house_address,
        'house_location': house_location,
        'house_city': house_city,
        'house_type': house_type,
        'house_size': house_size,
        'house_exdata': "ASSIGN",
        'owner_name': owner_name,
        'owner_email': owner_email,
        'owner_phone': owner_phone,
        'owner_address': owner_address,
        'owner_exdata': vendor_name,
        'lease_start_date': lease_start_date,
        'lease_end_date': lease_end_date,
        'property_type': "0",
        'rn_number': rn_number,
        'assigned_date': assigned_date
      }

      // this.validateData(s_no, houseData);

      var errorText = ""
      // console.log(houseData.house_size + ' houseData.house_size.length ' + houseData.house_size.length + ' ' + (houseData.house_size.length < 1))
      // console.log(houseData.owner_phone + ' houseData.owner_phone.length ' + houseData.owner_phone.length + ' ' + (houseData.owner_phone.length < 1))
      if (this.isInvalid(houseData.house_address)) {
        errorText = errorText + 'Invalid House Address :: '
      }
      if (this.isInvalid(houseData.house_city)) {
        errorText = errorText + 'Invalid House City :: '
      }
      if (this.isInvalid(houseData.house_location)) {
        errorText = errorText + 'Invalid House Location :: '
      }
      if (this.isInvalid(houseData.house_size)) {
        // errorText = errorText + "Invalid House Size :: "
        houseData.house_size = '0';
        // console.log(errorText);
      }
      if (this.isInvalid(houseData.house_type)) {
        errorText = errorText + 'Invalid House Type :: '
      }

      if (this.isInvalid(houseData.owner_name)) {
        errorText = errorText + 'Invalid Owner Name :: '
      }
      if (this.isInvalid(houseData.owner_email) || !this.validateEmail(houseData.owner_email)) {
        errorText = errorText + 'Invalid Owner Email :: '
      }
      if (this.isInvalid(houseData.owner_phone) || houseData.owner_phone.length < 10) {
        errorText = errorText + 'Invalid Owner phone ' + houseData.owner_phone + ' :: '
      }
      if (this.isInvalid(houseData.owner_address)) {
        errorText = errorText + 'Invalid Owner Address :: '
      }
      if (this.isInvalid(houseData.owner_exdata)) {
        errorText = errorText + 'Invalid Vendor Name :: '
      } else {
        var isVendorAvailable = false;
        for (var i = 0; i < this.vendorList.length; i++) {
          if (houseData.owner_exdata === this.vendorList[i].name) {
            // console.log('-----' + houseData.owner_exdata);
            // console.log(this.vendorList[i]);
            houseData.owner_exdata = this.vendorList[i].id
            isVendorAvailable = true;
          }
        }
        if (!isVendorAvailable) {
          errorText = errorText + 'Invalid Vendor Name - Not Found :: '
        }
      }

      if (this.isInvalid(houseData.lease_start_date)) {
        errorText = errorText + 'Invalid Lease Start Date :: '
      } else {
        var dateSplitArr = houseData.lease_start_date.split('-');
        console.log('dateSplit',dateSplitArr)
        if (dateSplitArr.length != 3 || dateSplitArr[0].length != 4 || dateSplitArr[1].length != 2 || dateSplitArr[2].length != 2) {
          errorText = errorText + 'Invalid Lease Start Date :: '
        }
      }

      if (this.isInvalid(houseData.lease_end_date)) {
        errorText = errorText + 'Invalid Lease End Date :: '
      } else {
        var dateSplitArr = houseData.lease_end_date.split('-');
        if (dateSplitArr.length != 3 || dateSplitArr[0].length != 4 || dateSplitArr[1].length != 2 || dateSplitArr[2].length != 2) {
          errorText = errorText + 'Invalid Lease End Date :: '
        }
      }

      if (this.isInvalid(houseData.assigned_date)) {
        errorText = errorText + 'Invalid Assigned Date :: '
      } else {
        var dateSplitArr = houseData.assigned_date.split('-');
        if (dateSplitArr.length != 3 || dateSplitArr[0].length != 4 || dateSplitArr[1].length != 2 || dateSplitArr[2].length != 2) {
          errorText = errorText + 'Invalid Assigned Date :: '
        }
      }

      // console.log('rn_number: ' + houseData.rn_number)
      if (this.isInvalid(houseData.rn_number)) {
        errorText = errorText + 'Invalid RN Number :: '
      } else {
        if (!houseData.rn_number.startsWith('RN') || (houseData.rn_number.length < 7)) {
          errorText = errorText + 'Invalid RN Number :: --> '
          // console.log('houseData.rn_number.length: ' + houseData.rn_number.length)
        } else {
          if (rnNumberSet.has(houseData.rn_number)) {
            errorText = errorText + 'Duplicate RN Number :: '
          } else {
            const isAssigned = await this.isHouseAssignedtoUser(houseData.rn_number)
            // console.log('-----> isAssigned value: ' + isAssigned);
            if (isAssigned) {
              errorText = errorText + 'House already assigned to ' + houseData.rn_number + ' :: '
            } else {
              const isRNNumberAvailable = await this.isRNNumberAvailable(houseData.rn_number)
              // console.log('-----> isRNNumberAvailable value: ' + isRNNumberAvailable);
              if (isRNNumberAvailable) {
                rnNumberSet.add(houseData.rn_number);
              } else {
                errorText = errorText + 'RN Number ' + houseData.rn_number + ' does not exist :: '
              }
            }
          }
        }
      }

      if (errorText.length > 0) {
        // console.log("----------" + errorText)
        this.statusList.push({ line_no: s_no, status: 'Error', error: errorText });
        this.displayValue = 1;
        this.uploadStatus = 3;
      } else {
        this.uploadList.push(houseData)
        this.progressIncrement();
      }

    }

    // console.log('this.statusList: ' + this.statusList)
    // console.log('this.uploadList: ' + this.uploadList)

    // console.log('-----', rnNumberSet)
    // console.log('-----', this.userList)

    if (this.statusList.length == 0 && this.uploadList.length > 0) {
      // console.log('inside if');
      for (var i = 0; i < this.uploadList.length; i++) {
        var item = this.uploadList[i];
        // console.log('----- ' + 'item.houseData ' + item.houseData);

        this.createHouseData(item);
      }
    }
  }

  progressIncrement() {
    if (this.cnt == this.sheetlength) {
      this.uploadStatus = 2;
    }
    //  // console.log("progresspercent",   Math.round(this.cnt * 100 / this.sheetlength)    );
    this.progresspercent = this.cnt * 50 / this.sheetlength;
    this.cnt++;
  }

  isInvalid(str) {
    console.log('invlaid', str)
    if (str === undefined || str == 'undefined' || str == null || str.length < 1)
      return true;
    else
      return false;
  }

  // GET DATA
  getVendorData() {
    this.vendorList = [];
    // console.log("GET VENDOR LIST");
    this.awserviceProvider.getActiveVendorlist().then(data => {
      this.vendorList = data.filter(res => res.vendor_type === "Home");
      console.log("vendorList", this.vendorList);
    });
  }

  validateEmail(emailStr) {
    var emailFormat = /\S+@\S+\.\S+/;
    if (emailFormat.test(emailStr)) {
      // console.log('------ test Email Valid: ', emailStr)
      return true;
    } else {
      // console.log('------ test Email Invalid: ', emailStr)
      return false;
    }
  }

  async isRNNumberAvailable(rn_number) {
    // console.log("Searching RN Number in RNC Users.....", rn_number);
    var isRNNumberAvailable = await this.awserviceProvider
      .rnUserFilter(rn_number)
      .then(result => {
        if (result.length === 0) {
          // console.log('--- RN number not available: ' + rn_number);
          return false;
        } else {
          // console.log("--- RN number details" + rn_number);
          // console.log(result);
          if (result.length > 0) {
            this.userList.push(result[0]);
          }
          return true;
        }
      })
      .catch(err => {
        console.log("err", err);
      });
    // console.log('----- isRNNumberAvailable: ' + isRNNumberAvailable);
    return isRNNumberAvailable;
  }

  async isHouseAssignedtoUser(rn_number) {
    // console.log("Checking House assigned to RN Number.....", rn_number);
    var isAssigned = await this.awserviceProvider
      .assignHomeFilter(rn_number)
      .then(result => {
        // console.log(result);
        if (result.length === 0) {
          // console.log('--- House not assigned to RN number: ' + rn_number);
          return false;
        } else {
          // console.log('--- House already assigned to RN number: ' + rn_number);
          return true;
        }
      })
      .catch(err => {
        console.log("err", err);
      });
    // console.log('----- isAssigned: ' + isAssigned);
    return isAssigned;
  }

  createHouseData(houseData) {
    console.log("Create House data called .....", houseData);
    // # CREATE RECORD #
    this.awserviceProvider
      .CreateHouseData(houseData)
      .then(result => {
        // this.getAllData();
        // this.displayHouseValue = 0;
        console.log('------ house master record created ------')
        console.log('result: ' + result)
        houseData.home_id = result.id;
        this.createAssignHouse(houseData);
      })
      .catch(err => {
        console.log("err", err);
      });
  }

  createAssignHouse(houseData) {
    console.log("Create AssignHouse called .....", houseData);
    var empData;
    for (var i = 0; i < this.userList.length; i++) {
      var user = this.userList[i];
      if (user.user_name === houseData.rn_number) {
        empData = user;
        break;
      }
    }

    var assignHouseData = {
      user_pid: empData.id, // user ID
      rn_id: houseData.rn_number,
      home_id: houseData.home_id,
      assigned_date: houseData.assigned_date,
      status: 'ASSIGN',
      ex_data: 0
    };

    // # CREATE RECORD #
    this.awserviceProvider
      .CreateAssignHouse(assignHouseData)
      .then(resultData => {
        console.log("createAssignHouse resultData: ", resultData);
        this.progressIncrement()
      })
      .catch(err => {
        console.log("err", err);
      });
  }

}
